import React from "react"
import { Link } from "gatsby"

const PostLink = ({ post }) => (
  <Link to={post.frontmatter.path} className="card-link">
    <article className="card ">
      {!!post.frontmatter.thumbnail && (
        <img src={post.frontmatter.thumbnail} alt={post.frontmatter.title + "- Featured Shot"} />
      )}
      <header>
        <div className="post-taxonomy">
          {!!post.frontmatter.category && (
            <span className="term -compact">{post.frontmatter.category}</span>
          )}
        </div>
        <h2 className="post-title">
          <span className="post-link">
            {post.frontmatter.title}
          </span>
        </h2>
        <div className="post-meta">{post.frontmatter.date}</div>
        <p className="post-excerpt">{post.excerpt}</p>
        {!!post.frontmatter.tags && (
          <div className="tag-row">
            {post.frontmatter.tags.map(tag => (
              <span className="tag" key={tag}>#{tag}</span>
            ))}
          </div>
        )}
      </header>
    </article>
  </Link>
)
export default PostLink
